/* ── COMPANY COPY ──
   Principles, focus areas and roadmap were duplicated (with drift) across
   Main and About. One definition, used by both. */

export const PRINCIPLES = [
  { name: 'Security', desc: 'Security-first architecture across every product — from credential handling and data transport to access control. Not a checkbox. The foundation everything else is built on.' },
  { name: 'Customization', desc: 'Users have different workflows, different environments, different needs. Our products adapt to them — not the other way around.' },
  { name: 'Privacy', desc: 'We collect only what is necessary and protect everything we touch. User data is never sold, never monetized, always handled with the seriousness it deserves.' },
  { name: 'Usability', desc: 'Powerful software should not require a manual. We obsess over clean interfaces and fast interactions that make the right action obvious from the very first use.' },
  { name: 'Future Proof', desc: 'Standards-based, modular, and designed to evolve. Our products do not require rebuilds every time the industry shifts direction.' },
  { name: 'Innovation', desc: 'We work on what users will need next, not what the market has already commoditized, and we publish the ideas we’re testing as research papers, including what they can’t do yet.' },
  { name: 'Trust', desc: 'No dark patterns. No hidden fees. No misleading claims. Trust is earned through consistent, honest behavior over time — and we take that seriously.' },
];

export const FOCUS_AREAS = [
  { name: 'Security', desc: 'Host-level defense, zero-trust architecture, and compliance automation built into every layer.' },
  { name: 'Infrastructure', desc: 'Control-plane and host management software for Linux, Windows, Docker, and Kubernetes at scale.' },
  { name: 'AI', desc: 'Focused, on-host tooling that helps operators — never a black box making the call for them.' },
];

export const ROADMAP = [
  { name: 'Windows & Kubernetes agent expansion', desc: 'Deeper signal coverage for the Windows and Kubernetes host agents.' },
  { name: 'Compliance automation', desc: 'Expanding automated evidence collection for SOC 2, HIPAA, and ISO 27001 audits.' },
  { name: 'Enterprise integrations', desc: 'Deeper SIEM, ticketing, and identity-provider integrations for large host fleets.' },
];

/* The stages a project moves through, from a written-up idea to archived.
   Papers (src/data/research.js) and products (src/data/products.js) each
   carry a `stage`; the About page's pipeline figure places them by it. */
export const STAGES = [
  { id: 'paper', label: 'Written up' },
  { id: 'prototype', label: 'Prototype' },
  { id: 'dev', label: 'In development' },
  { id: 'live', label: 'Shipping' },
  { id: 'archived', label: 'Archived' },
];

export const LINKEDIN = 'https://www.linkedin.com/in/aiden-mcelroy-b2630a379';
